var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { getCookie } from '@square/dashboard-utilities/utils/cookies';
import { generateEnvoyConsentHeader } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
const CLIENT_NAME_HEADER_KEY = 'apollographql-client-name';
const CSRF_TOKEN_HEADER_KEY = 'X-CSRF-Token';
const CSRF_TOKEN_COOKIE_KEY = '_js_csrf';

/**
 * !! IMPORTANT !!
 * This service is part of an effort to pilot using GraphQL on Dashboard.
 * If you are interested in using this service, please reach out to the
 * Web API Interfaces Working Group for more information.
 * Contact us in Slack: #proj-web-api-interfaces-wg
 * @experimental
 */
let Apollo = (_class = class Apollo extends Service {
  constructor(owner) {
    super(owner);
    _initializerDefineProperty(this, "environment", _descriptor, this);
    _defineProperty(this, "client", void 0);
    this.client = new ApolloClient({
      // This client is configured to work with the 1p-square graph only
      // Visit https://studio.apollographql.com/graph/block/variant/1p-square-staging/home to explore the schema
      uri: '/1p/graphql',
      connectToDevTools: !this.environment.isProduction,
      cache: new InMemoryCache(),
      headers: {
        ...generateEnvoyConsentHeader(),
        [CSRF_TOKEN_HEADER_KEY]: getCookie(CSRF_TOKEN_COOKIE_KEY) || document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        // Required by GraphQL Platform
        [CLIENT_NAME_HEADER_KEY]: 'seller-dashboard'
      }
    });
  }

  /**
   * Registers the query client instances to the window as globals so that
   * they can be consumed by dashboard-web, which is server-side rendered
   * and cannot be passed props during mount.
   */
  registerGlobals() {
    // eslint-disable-next-line dashboard/use-utilities-window
    window.__dashboardApolloClient = this.client;
  }
  get instance() {
    return this.client;
  }
  willDestroy() {
    // https://www.apollographql.com/docs/react/api/core/ApolloClient#clearstore
    // Clears all connected caches, necessary for cleanup on test teardown
    this.client.clearStore();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "environment", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Apollo as default };